import React from 'react';
import {StyleSheet, View} from 'react-native';
import GoogleMapReact from 'google-map-react';

function HeatMap({
                     centerLatLang,
                     height = 500,
                     width = '100%',
                     wrapperStyle = {},
                     coordinates = [],
                     autoCenter = false
                 }) {

    return (
        <View style={{
            height,
            width,
            padding: 30,
            ...wrapperStyle,
        }}>
            <GoogleMapReact
                defaultZoom={4}
                defaultCenter={centerLatLang}
                options={{gestureHandling: 'cooperative'}}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={async ({map, maps}) => {
                    const _origWarn = console.warn;
                    console.warn = function () {
                        if (typeof arguments[0] === 'string' && arguments[0].indexOf('weightsTexture') !== -1) return;
                        _origWarn.apply(console, arguments);
                    };

                    // new Function hides the import() from webpack's static analyzer
                    // so it becomes a native browser dynamic import at runtime
                    const esmImport = new Function('url', 'return import(url)');
                    const [{GoogleMapsOverlay}, {HeatmapLayer}] = await Promise.all([
                        esmImport('https://esm.sh/@deck.gl/google-maps@9'),
                        esmImport('https://esm.sh/@deck.gl/aggregation-layers@9'),
                    ]);

                    // deck.gl uses GeoJSON [longitude, latitude] order
                    const heatmapData = coordinates.map(c => ({position: [c.lng, c.lat]}));

                    const overlay = new GoogleMapsOverlay({
                        interleaved: false,
                        layers: [
                            new HeatmapLayer({
                                id: 'fluid-heatmap',
                                data: heatmapData,
                                getPosition: d => d.position,
                                getWeight: 1,
                                radiusPixels: 20,
                                colorRange: [
                                    [0, 255, 255, 0],
                                    [0, 255, 255, 255],
                                    [0, 191, 255, 255],
                                    [0, 127, 255, 255],
                                    [0, 63, 255, 255],
                                    [0, 0, 255, 255],
                                    [0, 0, 223, 255],
                                    [0, 0, 191, 255],
                                    [0, 0, 159, 255],
                                    [0, 0, 127, 255],
                                    [63, 0, 91, 255],
                                    [127, 0, 63, 255],
                                    [191, 0, 31, 255],
                                    [255, 0, 0, 255],
                                ],
                            }),
                        ],
                    });

                    overlay.setMap(map);

                    requestAnimationFrame(() => requestAnimationFrame(() => {
                        console.warn = _origWarn;
                    }));

                    if (autoCenter && coordinates.length > 0) {
                        const bounds = new maps.LatLngBounds();
                        for (const c of coordinates) {
                            bounds.extend(new maps.LatLng(c.lat, c.lng));
                        }
                        map.fitBounds(bounds);
                    }
                }}
            />
        </View>
    );
}

export default HeatMap;

const styles = StyleSheet.create({
    processingText: {
        color: '#FFFFFF',
        fontFamily: 'SourceSansPro-SemiBold',
        fontSize: 20,
        marginLeft: 20,
    },
});
